import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  background: ",
        ";\n  color: #ffffff;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 21px;\n  border-top: 1px solid ",
        ";\n\n  padding: 48px 0;\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n\n  .Footer-social-link-block {\n    display: flex;\n    align-items: center;\n    gap: 48px;\n    margin-top: 16px;\n  }\n\n  .footer-copy {\n    text-align: center;\n    margin-bottom: 6px;\n  }\n\n  .footer-copy {\n    margin-bottom: 6px;\n  }\n\n  .links {\n    display: flex;\n    align-items: center;\n  }\n\n  .links .link-item:not(:last-child) {\n    margin-bottom: 0px;\n    margin-right: 32px;\n  }\n\n  .link-item {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n  }\n\n  @media screen and (max-width: 991px) {\n    height: auto;\n\n    .links {\n      justify-content: center;\n      margin-top: 12px;\n    }\n  }\n  @media screen and (max-width: 576px) {\n    height: auto;\n    padding-top: 24px;\n    padding-bottom: 24px;\n    .links {\n      display: block;\n\n      .link-item {\n        text-align: center;\n        max-width: 254px;\n        margin: 0 auto !important;\n\n        @media (max-width: 700px) {\n          max-width: 100%;\n        }\n\n        &:not(:last-child) {\n          margin-bottom: 12px !important;\n        }\n      }\n    }\n  }\n\n  .links {\n    a {\n      margin-bottom: 6px;\n      color: #ffffff;\n      &:not(:last-child) {\n        margin-right: 32px;\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  max-width: 1360px;\n  width: 100%;\n  padding: 0 20px;\n  margin: 0 auto;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  height: 104px;\n  border-top: 1px solid rgba(255, 255, 255, 0.1);\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  @media screen and (max-width: 991px) {\n    width: auto;\n    padding-left: 24px;\n    padding-right: 24px;\n  }\n  @media screen and (max-width: 700px) {\n    flex-direction: column;\n    justify-content: center;\n    height: unset;\n    padding: 40px 0 16px 0;\n    width: auto;\n  }\n  @media screen and (max-width: 576px) {\n    border-top: none;\n    /* width: 100%; */\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from "react";
import styled from "styled-components";
import { DiscordLogoIcon, MediumLogoIcon, TelegramLogoIcon, TwitterXIcon } from "../Svg";
import { LinkExternal } from "../Link";
var SOCIAL_LINKS = [
    {
        link: "https://twitter.com/mummyftmfi",
        name: "Twitter",
        icon: TwitterXIcon
    },
    {
        link: "https://medium.com/@mummyftm",
        name: "Medium",
        icon: MediumLogoIcon
    },
    // { link: "https://github.com/gmx-io", name: "Github", icon: githubIcon },
    {
        link: "https://t.me/mummyftm",
        name: "Telegram",
        icon: TelegramLogoIcon
    },
    {
        link: "https://discord.gg/xqSJaw8sUB",
        name: "Discord",
        icon: DiscordLogoIcon
    }, 
];
var Wrap = styled.div.withConfig({
    componentId: "sc-704d8cee-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.backgroundAlt;
}, function(param) {
    var theme = param.theme;
    return theme.colors.white10;
});
var FooterBotWrapper = styled.div.withConfig({
    componentId: "sc-704d8cee-1"
})(_templateObject1());
var FooterBot = styled.div.withConfig({
    componentId: "sc-704d8cee-2"
})(_templateObject2());
var Footer = function() {
    return /*#__PURE__*/ _jsxs(Wrap, {
        className: "footer-site",
        children: [
            "Join our community",
            /*#__PURE__*/ _jsx("div", {
                className: "Footer-social-link-block",
                children: SOCIAL_LINKS.map(function(platform) {
                    var Icon = platform.icon;
                    return /*#__PURE__*/ _jsx(LinkExternal, {
                        hiddenIcon: true,
                        className: "App-social-link",
                        href: platform.link,
                        children: /*#__PURE__*/ _jsx(Icon, {})
                    }, platform.name);
                })
            })
        ]
    });
};
export default /*#__PURE__*/ memo(Footer);
